import React from "react";

export default function DialogModal({
  icon,
  iconColor,
  title,
  message,
  buttonTitle,
  isCancelButton,
  onSubmit,
  onClose,
}) {
  return (
    <div className="">
      <div className="bg-white p-8 w-80 text-center rounded">
        <div className="flex justify-center mb-2 mt-3">
          <i className={`${icon} fs-1`} style={{ color: iconColor }}></i>
        </div>
        <h5 className="text-black fw-bold mb-3">{title}</h5>
        <p className="text-black mb-4 ms-2 me-2">{message ?? ""}</p>
        <div className="d-flex justify-content-center text-center">
          {isCancelButton && (
            <button
              onClick={onClose}
              className="btn text-dark w-25 px-6 py-2 rounded-md mb-4 me-2"
              style={{ backgroundColor: "#d1d1d1" }}
            >
              Cancel
            </button>
          )}
          <button
            onClick={onSubmit}
            className="btn text-white w-25 px-6 py-2 rounded-md mb-4"
            style={{ backgroundColor: "#82c14a" }}
          >
            {buttonTitle || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}
